import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import PlayCircleOutlineIcon from '@material-ui/icons/PlayCircleOutline';

import Session from './Session';
import Blank from './Blank';

const useStyles = makeStyles(theme => ({
  room: {
    marginTop: theme.spacing(6),
    borderTop: '6px solid',
    borderTopColor: theme.palette.secondary.main,
    paddingBottom: theme.spacing(4),
  },
  grid: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(3)
  },
  title: {
    textTransform: 'uppercase',
    fontWeight: 500,
  },
  live: {
    fontSize: '0.7rem',
    backgroundColor: '#dc004e!important',
    color: '#fff!important'
  },
}));

const LiveButton = (props) => {
  const classes = useStyles();
  return (
    <>
      {props.config.currentSession &&
        <Button size="small" variant="contained" className={classes.live} disableElevation startIcon={<PlayCircleOutlineIcon />} onClick={e => props.setVideoSrc(props.config.currentSession)}>watch live</Button>
      }
    </>
  );
}

const Event = (props) => {
  if (props.config.status === "active") {
    return (
      <Session config={props.config} setVideoSrc={props.setVideoSrc} />
    )
  }
  if (props.config.status === "blank") {
    return (
      <Blank />
    )
  }
  return (<></>);
};

const Room = (props) => {
  const classes = useStyles();
  return (
    <div className={classes.room}>
      <Grid container direction="row" justify="space-between" alignItems="flex-start" className={classes.grid}>
        <Grid item>
          <h2 className={classes.title}>{props.config.name}</h2>
        </Grid>
        <Grid item>
          <LiveButton config={props.config} setVideoSrc={props.setVideoSrc} />
        </Grid>
      </Grid>
      {props.config.sessions.map((event, index) => (
        <div key={index}><Event config={event} setVideoSrc={props.setVideoSrc} /></div>
      ))}

    </div>
  );
};

export default (props) => {
  return (
    <Grid container direction="row" spacing={3}>
      {props.config.map((room, index) => (
        <Grid item md={6} xs={12} key={index}>
          <Room config={room} setVideoSrc={props.setVideoSrc} />
        </Grid>
      ))}
    </Grid>
  );
}
